import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
import { toast, Toaster } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useDemoSessao(tipo) {
  const [sid, setSid] = useState(null);
  const [estado, setEstado] = useState(null);
  const timer = useRef(null);
  const criando = useRef(false);
  const criar = useCallback(async () => {
    const atual = localStorage.getItem(`demo_sessao_${tipo}`);
    const substituir = atual && atual !== "null" && atual !== "undefined" ? atual : undefined;
    const r = await axios.post(`${API}/demo/sessao`, { tipo, substituir });
    localStorage.setItem(`demo_sessao_${tipo}`, r.data.id);
    setSid(r.data.id);
    return r.data.id;
  }, [tipo]);
  useEffect(() => {
    const salvo = localStorage.getItem(`demo_sessao_${tipo}`);
    if (salvo && salvo !== "null" && salvo !== "undefined") { setSid(salvo); return; }
    localStorage.removeItem(`demo_sessao_${tipo}`);
    if (criando.current) return;  // StrictMode/corrida: cria UMA sessão, um aviso
    criando.current = true;
    criar().catch((e) => toast.error(e?.response?.data?.detail || "Falha ao criar sessão demo"))
      .finally(() => { criando.current = false; });
  }, [tipo, criar]);
  useEffect(() => {
    if (!sid) return;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/demo/sessao/${sid}/estado`);
        setEstado(r.data);
      } catch (e) {
        if (e?.response?.status === 404) {
          clearInterval(timer.current);
          criar().catch((er) => toast.error(er?.response?.data?.detail || "Falha ao criar sessão demo"));
        }
      }
    };
    poll();
    timer.current = setInterval(poll, 4000);
    return () => clearInterval(timer.current);
  }, [sid, criar]);
  return { sid, estado, criar, setEstado };
}

export function BarraApresentador({ sid, tipo, criar, extra }) {
  const acao = async (path, msg) => {
    try { await axios.post(`${API}/demo/sessao/${sid}/${path}`); if (msg) toast.success(msg); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };
  const abrirComo = async (papel, rota) => {
    try {
      const r = await axios.post(`${API}/demo/sessao/${sid}/login`, { papel });
      sessionStorage.setItem("pim_token", r.data.token);
      sessionStorage.setItem("pim_role", r.data.role);
      window.location.href = rota;
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao abrir visão"); }
  };
  const continuarEmpresa = async () => {
    try {
      await axios.post(`${API}/demo/sessao/${sid}/continuar-empresa`);
      localStorage.setItem("demo_sessao_empresa", sid);
      toast.success("Etapa Empresa liberada — mesma sessão, dados preservados");
      setTimeout(() => { window.location.href = "/apresentacao-empresa"; }, 700);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao continuar"); }
  };
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-[#0B1020]/95 border-t border-[#126BFF]/30 backdrop-blur px-4 py-2.5 flex flex-wrap items-center gap-2 text-xs" data-testid="demo-barra">
      <span className="font-extrabold tracking-widest text-[#FF6700] uppercase mr-2">Modo Apresentação</span>
      <button onClick={() => acao("reset", "Demo reiniciada")} className="px-3 py-1.5 rounded-lg border border-[#126BFF]/40 text-[#6FA6FF] hover:bg-[#126BFF]/10 font-bold" data-testid="demo-reiniciar">🔄 Reiniciar Demo</button>
      {tipo === "particular" && (
        <button onClick={continuarEmpresa}
          className="px-3 py-1.5 rounded-lg bg-[#FF6700] text-white font-bold hover:bg-[#e05500]" data-testid="demo-continuar-empresa">▶ Continuar para Demo Empresa</button>
      )}
      <button onClick={async () => {
        if (window.confirm("Encerrar a apresentação? Os dados temporários desta sessão (Particular + Empresa) serão apagados. A rede demo e os Modelos permanecem.")) {
          await acao("encerrar", "Apresentação encerrada");
        }
      }} className="px-3 py-1.5 rounded-lg border border-red-500/50 text-red-400 hover:bg-red-500/10 font-bold" data-testid="demo-encerrar">⏹ Encerrar Apresentação</button>
      <button onClick={async () => {
        try { await criar(); toast.success("Nova apresentação criada"); }
        catch (e) { toast.error(e?.response?.data?.detail || "Falha ao criar nova apresentação"); }
      }}
        className="px-3 py-1.5 rounded-lg border border-[#00A859]/50 text-[#34D399] hover:bg-[#00A859]/10 font-bold" data-testid="demo-nova">✦ Nova Apresentação</button>
      <a href={`${API}/demo/sessao/${sid}/relatorio.pdf`} download
        className="px-3 py-1.5 rounded-lg border border-white/20 text-white/70 hover:bg-white/5 font-bold" data-testid="demo-relatorio">📄 Relatório (PDF)</a>
      <span className="mx-1 text-white/20">|</span>
      <button onClick={() => abrirComo("montador", "/montador")} className="px-3 py-1.5 rounded-lg bg-[#126BFF]/15 text-[#6FA6FF] font-bold hover:bg-[#126BFF]/25" data-testid="demo-abrir-montador">Abrir como Montador</button>
      <button onClick={() => abrirComo("empresa", "/admin")} className="px-3 py-1.5 rounded-lg bg-[#126BFF]/15 text-[#6FA6FF] font-bold hover:bg-[#126BFF]/25" data-testid="demo-abrir-empresa">Abrir como Empresa</button>
      <button onClick={() => abrirComo("montadora", "/montadora")} className="px-3 py-1.5 rounded-lg bg-[#126BFF]/15 text-[#6FA6FF] font-bold hover:bg-[#126BFF]/25" data-testid="demo-abrir-montadora">Abrir como Montadora</button>
      {extra}
    </div>
  );
}

export function FeedEventos({ eventos }) {
  return (
    <div className="space-y-2 max-h-[46vh] overflow-y-auto pr-1" data-testid="demo-eventos">
      {(eventos || []).map(ev => (
        <div key={ev.id} className={`rounded-xl border px-4 py-3 ${ev.tipo?.startsWith("whatsapp") ? "border-[#00A859]/40 bg-[#00A859]/5" : "border-[#126BFF]/25 bg-[#142766]/40"}`}>
          {ev.tipo === "whatsapp_simulado" && <div className="text-[10px] font-extrabold uppercase tracking-wider text-[#34D399] mb-1">📲 WhatsApp que o sistema enviaria agora</div>}
          {ev.tipo === "whatsapp_real" && <div className="text-[10px] font-extrabold uppercase tracking-wider text-[#FF6700] mb-1">🧪 WhatsApp REAL enviado ao número autorizado</div>}
          <div className="text-sm text-white/90 whitespace-pre-wrap leading-snug">{ev.titulo || ev.mensagem}</div>
          <div className="text-[10px] text-white/35 mt-1">{(ev.at || "").slice(11, 16)}</div>
        </div>
      ))}
    </div>
  );
}

export function CardMontadora({ mt }) {
  if (!mt) return null;
  return (
    <div className="mt-4 rounded-2xl border border-[#7C5CFF]/30 bg-[#7C5CFF]/5 p-4" data-testid="demo-montadora">
      <div className="text-[10px] font-extrabold uppercase tracking-wider text-[#A78BFA] mb-2">🏗️ Montadora Gestora — {mt.nome}</div>
      <div className="grid grid-cols-4 gap-2 text-sm">
        <div className="text-white/70">Capacidade<br /><b className="text-white">{mt.capacidade != null ? `${mt.capacidade}%` : "—"}</b></div>
        <div className="text-white/70">OS no ciclo<br /><b className="text-white">{mt.os_ciclo || 0} <span className="text-white/50 font-normal">({mt.concluidas || 0} concluídas)</span></b></div>
        <div className="text-white/70">Score<br /><b className="text-[#FFCC00]">⭐ {mt.score}</b></div>
        <div className="text-white/70">Repasse do ciclo<br /><b className="text-[#34D399]">R$ {Number(mt.repasse_ciclo || 0).toFixed(2)}</b></div>
      </div>
      {mt.capacidade_detalhe && <div className="text-[10px] text-white/40 mt-2">{mt.capacidade_detalhe}</div>}
    </div>
  );
}

export function CardFinanceiro({ fin }) {
  if (!fin || !fin.lancamentos) return null;
  return (
    <div className="mt-4 rounded-2xl border border-[#00A859]/30 bg-[#00A859]/5 p-4" data-testid="demo-financeiro">
      <div className="text-[10px] font-extrabold uppercase tracking-wider text-[#34D399] mb-2">💰 Financeiro em tempo real — Tabela de Valores</div>
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div className="text-white/70">Montador Demo<br /><b className="text-white">R$ {Number(fin.v_montador || 0).toFixed(2)}</b></div>
        <div className="text-white/70">Ébano e Marfim (gestora)<br /><b className="text-white">R$ {Number(fin.v_montadora || 0).toFixed(2)}</b></div>
        <div className="text-white/70">NFs simuladas<br /><b className="text-white">{fin.nfs || 0}</b></div>
      </div>
      <div className="text-[10px] text-white/45 mt-2">Repasse calculado conforme a regra real — lançamento Demo sem liquidação financeira.</div>
    </div>
  );
}

export default function ApresentacaoParticular() {
  const { sid, estado, criar } = useDemoSessao("particular");
  useEffect(() => { document.title = "MontaJá · Demonstração"; }, []);
  const sess = estado?.sessao;
  const resumo = estado?.resumo || {};
  const [trocaInfo, setTrocaInfo] = useState(null);
  const url = sid ? `${window.location.origin}/demo/cliente/${sid}` : "";

  const irTela = async (papel, rota) => {
    try {
      const r = await axios.post(`${API}/demo/sessao/${sid}/login`, { papel });
      sessionStorage.setItem("pim_token", r.data.token);
      sessionStorage.setItem("pim_role", r.data.role);
      window.location.href = rota;
    } catch (e) { toast.error("Erro ao abrir tela real"); }
  };
  // Plano B → redireciona a TV para a página REAL correspondente (mesma aba)
  const ROTAS_CENARIO = {
    "assistencia/agendar_retorno": ["montador", "/montador"],
    "troca/autorizar_ressarcimento": ["empresa", "/admin/cliente-particular"],
    "troca/confirmar_recolhimento": ["empresa", "/admin/pulmao"],
  };

  const cenario = async (cen, acaoStr, body = {}) => {
    try {
      const r = await axios.post(`${API}/demo/sessao/${sid}/cenario/${cen}/${acaoStr}`, body);
      if (cen === "troca" && r.data.lead) setTrocaInfo(r.data.lead);
      const rota = ROTAS_CENARIO[`${cen}/${acaoStr}`];
      if (rota) {
        toast.success("Etapa avançada — abrindo a tela real…");
        setTimeout(() => irTela(rota[0], rota[1]), 1200);
      } else {
        toast.success("Etapa avançada");
      }
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
  };

  if (sess && sess.status !== "ativa") {
    return (
      <div className="min-h-screen bg-[#0B1020] text-white flex flex-col items-center justify-center gap-6 p-8">
        <div className="text-4xl font-extrabold">Esta demonstração foi encerrada.</div>
        <div className="text-xl text-white/60">Obrigado por conhecer o MontaJá.</div>
        <a href={`${API}/demo/sessao/${sid}/relatorio.pdf`} target="_blank" rel="noreferrer"
          className="px-6 py-3 rounded-xl border border-white/20 font-bold" data-testid="demo-relatorio-final">📄 Baixar Relatório da Apresentação (PDF)</a>
        <button onClick={() => { localStorage.removeItem("demo_sessao_particular"); criar(); }}
          className="px-6 py-3 rounded-xl bg-[#FF6700] font-bold" data-testid="demo-nova-apos-encerrar">Nova Apresentação</button>
        <Toaster richColors />
      </div>
    );
  }
  const tt = resumo?.participante ? null : null;
  return (
    <div className="min-h-screen bg-[#0B1020] text-white pb-20">
      <Toaster richColors />
      <div className="max-w-7xl mx-auto px-6 py-8 grid lg:grid-cols-2 gap-10">
        <div>
          <div className="text-[11px] font-extrabold uppercase tracking-[0.25em] text-[#FF6700]">MontaJá · Showroom</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Experimente o MontaJá<br />como <span className="text-[#FF6700]">seu cliente.</span></h1>
          <p className="mt-3 text-white/60 max-w-md">Escaneie o QR Code com o celular e viva a jornada completa: oferta, contrato, pagamento, agendamento e montagem.</p>
          {url && (
            <div className="mt-8 bg-white p-6 rounded-3xl inline-block" data-testid="demo-qr">
              <QRCodeSVG value={url} size={280} />
            </div>
          )}
          <div className="mt-3 text-xs text-white/40 break-all">{url}</div>
          {resumo.participante && (
            <div className="mt-6 rounded-2xl border border-[#126BFF]/30 bg-[#142766]/50 p-5" data-testid="demo-resumo">
              <div className="text-[10px] font-extrabold uppercase tracking-wider text-[#6FA6FF]">Pedido do participante</div>
              <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                <div>Protocolo: <b>{resumo.participante.protocolo}</b></div>
                <div>Status: <b className="text-[#FF6700]">{resumo.participante.status}</b></div>
                {resumo.servico && (<>
                  <div>OS: <b>{resumo.servico.pim_code}</b></div>
                  <div>Status OS: <b className="text-[#34D399]">{resumo.servico.status}</b></div>
                  <div>Data: <b>{resumo.servico.data_confirmada || "—"}</b></div>
                  <div>Montador: <b>{resumo.servico.montador_id ? "Montador Demo" : "aguardando"}</b></div>
                  <div>Gestora: <b>Ébano e Marfim (Demo)</b></div>
                </>)}
              </div>
              {resumo.score_montador != null && (
                <div className="mt-3 text-sm">⭐ Score do Montador Demo: <b className="text-[#FFCC00]">{resumo.score_montador}</b></div>
              )}
            </div>
          )}
          <CardFinanceiro fin={resumo.financeiro} />
          <CardMontadora mt={resumo.montadora} />
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="w-full text-[10px] font-extrabold uppercase tracking-widest text-white/40">Plano B — cenários pré-definidos</span>
            <div className="rounded-2xl border border-[#FFCC00]/30 bg-[#FFCC00]/5 p-4 w-full">
              <div className="font-bold text-[#FFCC00] text-sm mb-2">🔧 Demonstrar Assistência Técnica</div>
              <div className="flex flex-wrap gap-1.5">
                {[["peca_solicitada", "Peça solicitada"], ["peca_recebida", "Peça recebida"],
                  ["agendar_retorno", "Agendar retorno"], ["concluir_retorno", "Concluir retorno"],
                  ["avaliar", "Avaliar ⭐5"]].map(([a, l]) => (
                  <button key={a} onClick={() => cenario("assistencia", a, a === "avaliar" ? { estrelas: 5 } : {})}
                    className="px-3 py-1.5 rounded-lg bg-[#142766] border border-[#126BFF]/30 text-xs font-bold hover:bg-[#126BFF]/20"
                    data-testid={`demo-asst-${a}`}>{l}</button>
                ))}
              </div>
            </div>
            <div className="rounded-2xl border border-red-400/30 bg-red-500/5 p-4 w-full" data-testid="demo-troca-card">
              <div className="font-bold text-red-300 text-sm mb-1">🔁 Demonstrar Troca Total — Cliente Particular</div>
              <div className="text-xs text-white/70 mb-2 grid grid-cols-3 gap-1">
                <span>Valor do Produto: <b>R$ 1.000,00</b></span>
                <span>Ressarcimento à Loja: <b>65%</b></span>
                <span>Valor: <b className="text-[#FF6700]">R$ 650,00</b></span>
              </div>
              <div className="text-[10px] text-white/50 mb-2">"Crédito destinado à Loja para reposição do produto e reenvio de um novo item ao cliente."</div>
              <div className="flex flex-wrap gap-1.5">
                <button onClick={() => cenario("troca", "autorizar_ressarcimento")}
                  className="px-3 py-1.5 rounded-lg bg-[#FF6700] text-xs font-extrabold" data-testid="demo-troca-autorizar">Simular Autorização do Ressarcimento à Loja</button>
                <button onClick={() => cenario("troca", "produto_reenviado")}
                  className="px-3 py-1.5 rounded-lg bg-[#142766] border border-[#126BFF]/30 text-xs font-bold" data-testid="demo-troca-reenviado">Loja informou reenvio</button>
                <button onClick={() => cenario("troca", "confirmar_recolhimento")}
                  className="px-3 py-1.5 rounded-lg bg-[#142766] border border-[#126BFF]/30 text-xs font-bold" data-testid="demo-troca-recolhimento">Confirmar recolhimento (→ Pulmão)</button>
              </div>
              {trocaInfo && <div className="mt-2 text-xs text-[#34D399]">Status do caso: <b>{trocaInfo.status}</b>{trocaInfo.troca_total ? ` · Ressarcimento R$ ${Number(trocaInfo.troca_total.valor_ressarcimento).toFixed(2)}` : ""}</div>}
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-lg font-extrabold">O que está acontecendo?</h2>
            <span className="text-[10px] px-2 py-1 rounded bg-[#126BFF]/15 text-[#6FA6FF] font-bold uppercase">{sess?.etapa_atual || "—"}</span>
          </div>
          <FeedEventos eventos={estado?.eventos} />
        </div>
      </div>
      <BarraApresentador sid={sid} tipo="particular" criar={criar} />
    </div>
  );
}
